var _path, _rect, _circle, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConnAmplitude(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H94C98.4183 0 102 3.58172 102 8V94C102 98.4183 98.4183 102 94 102H8C3.58172 102 0 98.4183 0 94V8Z",
    fill: "#E4E4F9"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15.5,
    y: 15.5,
    width: 71,
    height: 71,
    fill: "#10059F",
    stroke: "#313131"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50.5069,
    cy: 51.4952,
    r: 33.5342,
    fill: "#10059F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.8427 47.7365C40.2525 39.7796 42.8539 31.8102 44.4986 32.468C45.7361 32.963 47.8315 39.952 50.1781 47.9761L37.8427 47.7365ZM32.359 52.4678C31.0113 58.1811 30.5774 62.7543 32.3703 62.9607C32.4516 62.9701 32.5313 62.9672 32.5989 62.9212C33.385 62.3865 34.7961 57.8691 36.4206 52.4678H51.4925C53.5153 59.3434 55.6359 66.2418 57.4991 69.9683C61.9991 78.9683 67.9986 69.468 69.4992 62.968C69.9861 60.8587 70.4297 58.3298 70.7747 56.0965C70.9455 54.9906 70.075 54.7954 69.736 55.8618C67.8976 61.6442 65.5845 68.468 62.9986 68.468C61.2763 68.468 58.8431 60.8486 56.4614 52.4678H73.4806C74.5959 52.4678 75.5 51.5636 75.5 50.4483C75.5 49.3483 74.6196 48.4507 73.5198 48.4293L55.2308 48.0742C55.0968 47.5912 54.9634 47.1097 54.8308 46.6308C52.9253 39.7513 51.1735 33.4265 49.9991 31.4683C47 26.4678 44 25.4684 40.4991 29.4683C39.3138 30.8227 35.9659 39.4807 33.6246 47.6546L26.5238 47.5168C25.1379 47.4899 24 48.6059 24 49.992C24 51.3593 25.1084 52.4678 26.4757 52.4678H32.359Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnAmplitude);
export default __webpack_public_path__ + "static/media/conn_amplitude.c3625f67bbf0de117acf65cb5d785ccb.svg";
export { ForwardRef as ReactComponent };